import { useState } from 'react';
import { useParams } from 'react-router';
import OutletSummary from './OutletSummary';
import { useUserContext } from '../../../contexts/UserContext';
import LockPage from '../../../components/LockPage';
import { ElementIdProvider } from './elementId';
import OutletLinker from './OutletLinker';
import LinkedOutletsDrawer from './LinkedOutletsDrawer';

export const FavePassOutletSettingsView = () => {
  const { getPageSettings } = useUserContext();
  const pageSettings = getPageSettings('partners');
  const enableViewOutletsList = !!pageSettings?.show_fave_passes;
  const enableLinkOutlets = !!pageSettings?.update_fave_passes;

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const { favePassId } = useParams();
  const passId = favePassId ? parseInt(favePassId) : 0;

  return enableViewOutletsList ? (
    <ElementIdProvider>
      <OutletSummary
        favePassId={passId}
        onLinkedOutletsClicked={() => setIsDrawerOpen(true)}
      />

      <OutletLinker
        favePassId={passId}
        enableViewOutletsList={enableViewOutletsList}
        enableLinkOutlets={enableLinkOutlets}
      />

      <LinkedOutletsDrawer
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        favePassId={passId}
        enableViewOutletsList={enableViewOutletsList}
        enableUnlinkOutlets={enableLinkOutlets}
      />
    </ElementIdProvider>
  ) : (
    <LockPage />
  );
};
